import * as madnes from "../../framework/src/engine/madnes/madnes";

import {madnes_set_win_factors} from "../../framework/src/engine/madnes/madnes";
import {madnes_set_sprite} from "../../framework/src/engine/madnes/madnes";
import {madnes_set_default_volume} from "../../framework/src/engine/madnes/madnes_audio";
import {
    ib27_infomenu_close,
    ib27_infomenu_init,
    ib27_infomenu_left,
    ib27_infomenu_open,
    ib27_infomenu_right,
    ib27_infomenu_update,
    ib27_print_desk, openinfo
} from "../ib27_reels";
import {ib27_print_reels} from "../ib27_core_printer";
import {ib27_end_round_recalced, ib27_rotate_run} from "../ib27_core";
import {GAME_EVENTS} from "../../framework/src/game/gameEvents";
import {WALLET_EVENTS} from "../../framework/src/wallet/Wallet";
import {server_config, server_result, systemConfig, wallet} from "../../framework/src/engine/madnes/madnes_variables";
import {CONFIG_PARAMS, MODES} from "../../framework/src/system/SystemConfig";
import eventsObservable from "../../framework/src/events/EventsObservable";
import { main_phaser } from "../../framework/src/engine/madnes/MadnesApp";


export const infotexts_languages = [
    "cs", "de", "en", "es", "fi", "hr", "no", "pl", "ro", "ru", "sr", "sv", "tr", "sk", "es-mx", "bg", "fr", "it"
];

export function initGame(gameset) {

    madnes.set_ico_size(362, 290 - 90);

    madnes_set_win_factors(25, 50, 125);

    madnes_set_sprite("coins", 152, 152);

    madnes_set_sprite('_sprite', 362, 290);
    madnes_set_sprite('_blur', 362, 290);

    madnes_set_sprite('wheel_sprite', 580, 580);
    madnes_set_sprite('shot_sprite', 154, 126);
    madnes_set_sprite('colt_sprite', 188, 534);
    madnes_set_sprite('bonus_Winfont_Big', 64, 108);
    madnes_set_sprite('bonus_Winfont_Small', 64, 108);
    madnes_set_sprite('big-win_Start_sprite', 1280, 800);
    madnes_set_sprite('intro_sprite_', 1280, 800);

    madnes_set_default_volume(0.8);

    if (systemConfig.get(CONFIG_PARAMS.MODE) === MODES.REPLAY) {
        eventsObservable.subscribe(
            GAME_EVENTS.GAME_ADD_RESULT,
            (eventName, data) => notify(eventName, data)
        )
    }
}

export function notify(eventName, data, prevData) {

    switch(eventName) {

        case GAME_EVENTS.GAME_FREESPIN_END:
        case GAME_EVENTS.GAME_END_ROUND_FREESPINS:
            freespins_end_round(eventName, data);
            break;

        case GAME_EVENTS.GAME_END_ROUND_RECALCED:
            end_round_recalced(eventName, data);
            break;

        case WALLET_EVENTS.WALLET_ON_SET_BET:
            ib27_infomenu_update();
            break;

        case GAME_EVENTS.GAME_ADD_RESULT:
            if (systemConfig.get(CONFIG_PARAMS.MODE) === MODES.REPLAY) {
                server_config.logic.specifics = server_result.logic.specifics = server_result.math_result.gameSpecifics
            }
            break;

        // case ACTION_EVENTS.ACTION_BETMENU_OPEN:
        //     soe_lines_open();
        //     break;

        // //case ACTION_EVENTS.ACTION_BETMENU_CLOSE:
        //     soe_lines_close(data);
        //     break;

        // case UISLIDER_EVENTS.UISLIDER_CHANGE_LINES:
        //     // soe_lines_change();
        //     break;
    }
}

export function on_set_bet() {
    infomenu_update();
}

export function game_start() {
    main_phaser.time.desiredFps = 120;
    ib27_rotate_run()
}

export function print_desk() {
    ib27_print_desk()
}

export function print_reels() {
    ib27_print_reels();
}

export function infomenu_init() {
    ib27_infomenu_init();
}

export function infomenu_open() {
    ib27_infomenu_open();
}

export function infomenu_close() {
    ib27_infomenu_close();
}

export function is_info_open() {
    return openinfo;
}

export function infomenu_left() {
    ib27_infomenu_left();
}

export function infomenu_right() {
    ib27_infomenu_right();
}

export function infomenu_update() {
    ib27_infomenu_update();
}

export function end_round_recalced(eventName, {autostart}) {
    ib27_end_round_recalced();

    if(!autostart) {
        end_round_no_autostart();
    }
}

export function end_round_no_autostart() {}

export function freespins_end_round(eventName, {ended}) {}

export function get_preinfo() {}

export function preinfo_close() {}
